module.exports = __webpack_public_path__ + "img/logo.dbf10883.png";